var _g, _circle, _g2, _use, _path, _use2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlackText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1006.995,
    height: 76.021,
    viewBox: "0 0 944.058 71.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.943 -423.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.943 426.699h38.386M88.388 425.362v69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a",
    fillRule: "evenodd",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 494.362h-3l26-69 26 69h-3l-23-62z",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 465.362h26",
    fill: "none",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185 494.362v-29l-23-40h4l20.75 36.113 20.75-36.113h4l-23 40v29z",
    fillRule: "evenodd",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    id: "d",
    transform: "translate(104.5)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.43 494.362l-.353-69",
    id: "c",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.34 494.455v-69.297l39.93 69.16v-68.983",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3.5,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(619.602 .354)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.509 427.103H738v32.527h31.155H738v33.234h31.686",
    id: "e",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(210.187 -.009)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "translate(313.042 -.375)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "translate(-344 -.252)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 425.362v67.25h28.75M440.75 494.362l-.25-69",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 813.807,
    cy: 35.939,
    r: 32.75,
    fill: "none",
    stroke: "#000",
    strokeWidth: 3.5,
    strokeLinejoin: "bevel"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "f",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M863.307 70.438V3.188h15.5c25 2.75 24.931 41.25 0 41.25h-15.75",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946 468.612l17 25.75h4l-17-25.875z",
    transform: "translate(-68.943 -423.924)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "translate(-148)",
    width: "100%",
    height: "100%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M935.502 10.604s-.53-7.248-11.137-7.601c-7.774-.26-12.816 6.01-12.816 12.816 0 6.806 6.075 10.432 12.816 13.7 11.668 5.657 17.943 12.763 17.943 22.009 0 9.57-6.452 17.766-17.766 17.766-11.314 0-16.617-6.895-18.385-14.673",
    id: "g",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.5
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "translate(-491.5 -.605)",
    width: "100%",
    height: "100%"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372.62 32.126l23.625-30.688h4.812l-21 27.75 27 41.25h-4.937l-24.625-38.25-4.688 5.5zM278.057 70.438l-32-69h-4l32 69z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.682 35.313h-24l2.625 3.625 22.625-.125z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.557 39.563h-23.5l1.822 3.156h23.553z",
    fillRule: "evenodd",
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlackText);
export default __webpack_public_path__ + "static/media/Logo_BlackText.729e0cb8a8b88b575034d7f77c845c6f.svg";
export { ForwardRef as ReactComponent };